<template>
    <div class="kyc-summary">
        <div class="proposed-table p-3">
            <b-row>
                <b-col cols="12" md="6">
                    <TotalAssetsTable :proposal="proposal" :current_customer="customer"/>
                </b-col>
                <b-col cols="12" md="6">
                    <el-button size="small" v-if="!has_expenses && (_gHlp.getValue(variable_expenses,'data','')).length > 0" class="bg-primary text-white float-right mb-2" @click="sync">Sync</el-button>
                    <VariableExpensesTable :variable_expenses="variable_expenses" :has_report="has_report"/>
                </b-col>
            </b-row>
        </div>

        <div class="acknowledgement">
            <div class="proposed-table">
                <b-table-simple responsive bordered>
                    <b-thead>
                        <b-tr>
                            <b-th>Acknowledgement</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(acknowledgement, index) in acknowledgements" :key="index">
                            <b-td>
                                <div class="d-flex align-items-center">
                                    <b-form-textarea
                                        v-model="acknowledgement.pack_content"
                                        size="sm"
                                        rows="3"
                                        class="border-0"
                                        @change="updateProposalAcknowledgement(acknowledgement, index)"
                                    ></b-form-textarea>
                                    <b-icon icon="check-circle-fill" variant="success" class="ml-2 cursor-pointer" 
                                        @click="saveProposalAcknowledgement(acknowledgement, index)" v-if="!acknowledgement.pack_id">
                                    </b-icon>
                                    <b-icon icon="x-circle-fill" variant="danger" class="mx-2 cursor-pointer"
                                         @click="deleteProposalAcknowledgement(acknowledgement.pack_id, index)"
                                    ></b-icon>
                                </div>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-td>
                                <span class="cursor-pointer text-primary" @click="addProposalAcknowledgement">+ Add</span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <div class="text-right" v-if="is_updated">
                    <p class="text-success m-0 p-0">Successfully Updated.</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import TotalAssetsTable from '@/views/InitialProposal/SubDetails/SectionItems/TotalAssetsTable'
import VariableExpensesTable from '@/views/InitialProposal/SubDetails/SectionItems/VariableExpensesTable'
import { axios, services, getHeader, notifyFunctionMixin } from '@/assets/js/httpImports.js'
import { Button } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useFinancialProposalStore } from '@/stores/financialProposalStore'

export default {
    props:['proposal', 'variable_expenses', 'customer', 'has_report'],
    mixins: [notifyFunctionMixin],
    components: {
        TotalAssetsTable,
        VariableExpensesTable,
        [Button.name]: Button,
    },
    data() {
        return {
            acknowledgements: [],
            is_updated: false,
            has_expenses: true,
        }
    },
    computed: {
		...mapState(useFinancialProposalStore, ['financial_proposal']),
    },
    watch:{
        'proposal.acknowledgements':{
            handler(newVal){
                this.acknowledgements = newVal
            },
            immediate: true
        },
        financial_proposal: {
            handler(newVal) {
                if(newVal) {
                    this.checkExistingFinancialProposalExpense()
                }
            }
        }
    },
    methods:{
        addProposalAcknowledgement(){
            this.acknowledgements.push({
                pack_content: ''
            })
        },
        saveProposalAcknowledgement(acknowledgement, index){
            if(acknowledgement.pack_content === ''){
                return
            }
            let data = {
                pack_psal_id: this.proposal.psal_id,
                pack_content: acknowledgement.pack_content
            }
            axios.post(services.initial_proposal + 'acknowledge', data, {headers: getHeader()} )
                .then(res=>{
                    this.is_updated = true
                    setTimeout(() => {
                        this.is_updated = false
                    }, 1000);
                    this.acknowledgements[index] = res.data
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        updateProposalAcknowledgement(acknowledgement, index){
            if(acknowledgement.pack_content === '' || !acknowledgement.pack_id){
                return
            }

            let data = {
                pack_content: acknowledgement.pack_content
            }

            axios.post(services.initial_proposal + 'acknowledge/'+acknowledgement.pack_id, data, {headers: getHeader()} )
                .then(res=>{
                    this.is_updated = true
                    setTimeout(() => {
                        this.is_updated = false
                    }, 1000);
                    this.acknowledgements[index] = res.data
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        deleteProposalAcknowledgement(acknowledgement_id, index){
            if(!acknowledgement_id){
                this.acknowledgements.splice(index, 1)
                return
            }
            axios.post(services.initial_proposal + 'acknowledge/delete/' + acknowledgement_id, null, {headers: getHeader()} )
                .then(res=>{
                    this.acknowledgements.splice(index, 1)
                    this.is_updated = true
                    setTimeout(() => {
                        this.is_updated = false
                    }, 1000);
                })
                .catch(e => {
                    this.errorFunction(e)
                })
        },
        checkExistingFinancialProposalExpense() {
            axios.get(services.financial_proposal + 'get_customer_expense/' + this.financial_proposal.financial_proposal_id, { headers: getHeader() })
				.then(res => {
                    let customer_expenses_data = res.data.data.customer_expenses_data
                    if(_gHlp.isEmpty(customer_expenses_data))
                    {
                        this.has_expenses = false
                    }
                    else
                    {
                        this.has_expenses = true
                    }
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
        },
        sync() {
            axios.get(services.financial_proposal + 'get_customer_expense_from_kyc/' +this.financial_proposal.financial_proposal_id + '/' + this.proposal.psal_customer_id, { headers: getHeader() })
				.then(res => {
                    if(res.status == 200)
                    {
                        this.has_expenses = true
                    }
                    _gNotif.notifySuccess('Synconization Completed.', 1000);
				})
				.catch(e => {
					_gNotif.errorFunction(e)
				})
        }
    }
}
</script>